<script setup lang="ts">
import type { IExchangeOffice } from '~/components/entity/exchange-office/item/types'
import type { IEntityPosition } from '~/components/entity/base-entity'
import { UiCardTop } from '~/components/ui/card'
import { EntityOrganizationLogo } from '~/components/entity/organization-logo'

const props = withDefaults(
  defineProps<{
    item: IExchangeOffice
    hideOrganizationDetails?: boolean
    position?: IEntityPosition
  }>(),
  {
    hideOrganizationDetails: false,
    position: undefined
  }
)

const isHighlighted = useEntityHighlight(props.item, props.position)

const { splitPhones } = usePhone()
const fitPhones = computed(() => splitPhones(props.item.mobile_phone))
</script>

<template>
  <article :class="[isHighlighted ? 'CardPremium group' : 'Card']">
    <UiCardTop v-if="isHighlighted" />
    <div class="EntityCardLayout">
      <div class="flex gap-4">
        <EntityOrganizationLogo
          v-if="!props.hideOrganizationDetails"
          :src="props.item.logo"
          :alt="props.item.title"
          :highlighted="isHighlighted"
        />
        <div>
          <div>
            <Heading tag="h3" class="hit-title h6">
              <span v-hydrated-html="props.item.title" />
            </Heading>
          </div>
          <p
            v-if="props.item.head_branch_location"
            v-hydrated-html="props.item.head_branch_location"
            class="SecondaryTextHeadings"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-y-2">
        <div v-if="props.item.license">
          <div class="SecondaryTextHeadings">{{ $t('common.license') }}</div>
          <div class="font-semibold">{{ props.item.license }}</div>
        </div>
        <div v-if="props.item.okpo">
          <div class="SecondaryTextHeadings">{{ $t('common.okpo') }}</div>
          <div class="font-semibold">{{ props.item.okpo }}</div>
        </div>
      </div>
    </div>
    <div
      v-if="fitPhones.length"
      class="flex flex-col gap-2 text-sm sm:flex-row"
      :class="props.hideOrganizationDetails ? '' : 'sm:mt-2'"
    >
      <div class="font-semibold">{{ $t('common.phone') }}:</div>
      <div class="text-blue-600">
        <template v-for="(phone, i) in fitPhones" :key="i">
          <a :href="`tel:${phone.tel}`" class="whitespace-nowrap hover:underline">
            {{ phone.label }}
          </a>
          <span v-if="i < fitPhones.length - 1">, </span>
        </template>
      </div>
    </div>
  </article>
</template>
